import { Form, Input } from "antd";
import PropTypes from "prop-types";

const AddCarModel = ({ t, selectedCarModel, setSelectedCarModel }) => (
    <div>
        <p className="text-md font-medium mb-2">{t("carModel")}</p>
        <Form.Item>
            <Input
                placeholder={t("carModel")}
                value={selectedCarModel.model}
                onChange={(e) => {
                    setSelectedCarModel((prev) => ({
                        ...prev,
                        model: e.target.value,
                    }));
                }}
            />
        </Form.Item>
    </div>
);

AddCarModel.propTypes = {
    t: PropTypes.func.isRequired,
    selectedCarModel: PropTypes.object.isRequired,
    setSelectedCarModel: PropTypes.func.isRequired,
};

export default AddCarModel;
